import { getFeatureFlags } from 'core/flow-control';
import { REGION } from 'core/constants/report-type';
import { useFiltersConfiguration } from 'features/explore/hooks/use-explore-persistent-filter';

export const useExploreMarketType = () => {
    const { enable_explore_markets_ff } = getFeatureFlags();
    const { type } = useFiltersConfiguration();

    return enable_explore_markets_ff && type === REGION;
};
